import React from "react";
import { Box, Typography, Container, Paper } from "@mui/material";

const DataPrivacy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>Privacy Policy</Typography>

  <Typography paragraph>
    We at Share a Secret are committed to protecting your privacy. This policy explains what data we collect, how we use it, and your rights.
  </Typography>

  <Typography variant="h6" gutterBottom>1. No Personal Data Collection</Typography>
  <Typography paragraph>
    We do not collect or store personally identifiable information (PII). No names or tracking IDs are recorded. To prevent abuse, our servers temporarily process a one-way hashed identifier derived from your network address for rate limiting. The raw IP address is never stored, and the hashed value is automatically deleted after a short period.
  </Typography>

  <Typography variant="h6" gutterBottom>2. Email Authentication</Typography>
  <Typography paragraph>
    If email-based protection is used, we store the email address solely for access control through Firebase Authentication. No other PII is stored or processed.
  </Typography>

  <Typography variant="h6" gutterBottom>3. Encryption</Typography>
  <Typography paragraph>
    All secrets are encrypted end-to-end. The encryption key is stored in the URL fragment (after the <code>#</code>) and is not transmitted to the server. However, the key can leave your device if the full URL is shared or browser plugins or tools access the URL.
  </Typography>

  <Typography variant="h6" gutterBottom>4. Cookies</Typography>
  <Typography paragraph>
    We only use strictly necessary cookies: one for theme preference and temporary ones for authentication sessions. No tracking or analytics cookies are used.
  </Typography>

  <Typography variant="h6" gutterBottom>5. Data Retention</Typography>
  <Typography paragraph>
    Secrets and metadata are automatically deleted based on the settings defined by the creator or after 30 days of inactivity.
  </Typography>

  <Typography variant="h6" gutterBottom>6. Your Rights</Typography>
  <Typography paragraph>
    Since no personal data is collected or stored beyond optional email access control, your rights under GDPR or similar laws are inherently respected.
  </Typography>

  <Typography variant="h6" gutterBottom>7. Contact</Typography>
  <Typography paragraph>
    For questions about this policy, contact us at privacy@share-a-secret.com
  </Typography>

  <Typography paragraph>
    Last updated: July 1, 2026
  </Typography>
      </Paper>
    </Container>
  );
};

export default DataPrivacy;
